import Type from 'Controller/Resource/Resource.type';

export default {
  [Type.SELECT_RESOURCE]: (store: any, next: any, action: any) => {
    next(action);
  },
};
